import {Dinero} from 'dinero.js'

const hideZeroCents = (dinero: Dinero) =>
  dinero.hasSubUnits() ? dinero.toFormat() : dinero.toFormat('$0,0')

export {hideZeroCents}
